module.exports = ".button-actions {\n    width: 200px;\n}\n\n.hierarchy-empty {\n    font-size: 25px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component.css
// module id = ./src/app/views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component.css
// module chunks = main